import React from 'react'
import config from 'const/config'
import { Helmet } from 'react-helmet-async'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from 'redux/store'

const DynamicYield = () => {
  const isDyEnabled = useSelector(
    (state: RootState) => state.akamaiConfig.isDyEnabled,
    shallowEqual
  )
  const dyScripts = [
    `//cdn.dynamicyield.com/api/${config.DY_SECTION_ID}/api_dynamic.js`,
    `//cdn.dynamicyield.com/api/${config.DY_SECTION_ID}/api_static.js`
  ]
  const dyLinks = [
    '//cdn.dynamicyield.com',
    '//st.dynamicyield.com',
    '//rcom.dynamicyield.com'
  ]

  return (
    isDyEnabled && (
      <Helmet>
        {dyScripts.map(dyScript => (
          <script src={dyScript} type="text/javascript" async key={dyScript} />
        ))}
        {dyLinks.map(dyLink => (
          <React.Fragment key={dyLink}>
            <link href={dyLink} rel="preconnect" />
            <link href={dyLink} rel="dns-prefetch" />
          </React.Fragment>
        ))}
      </Helmet>
    )
  )
}

export default DynamicYield
